var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper } from '@tanstack/react-table';
import { formatters } from 'common';
import { TextBody } from '../../atoms';
import { NoDataPlaceholder, Tag } from '../../molecules';
import { AmountQuantity } from '../amount-quantity';
import { Table } from '../table';
import { API } from '@xbto/api-client';
const columnHelper = createColumnHelper();
const columns = [
    columnHelper.accessor('creationDate', {
        cell: info => {
            const date = info.getValue();
            return (
            // @ts-expect-error This is web only : prevent text wrapping for long month like November
            _jsx(TextBody, { color: "primary", style: { whiteSpace: 'nowrap' }, children: formatters.getDate(date, 'MMMM yyyy', true) }));
        },
        header: 'Date',
        meta: { justify: 'flex-start', sortable: true },
    }),
    columnHelper.accessor('activityLabel', {
        cell: info => {
            const label = info.getValue();
            const title = label === API.ActivityLabel.FundRedemption
                ? 'Redemption'
                : label === API.ActivityLabel.FundSubscription
                    ? 'Subscription'
                    : label;
            return _jsx(TextBody, { em: true, children: title });
        },
        header: 'Transaction type',
        meta: { autoWidth: true, justify: 'flex-start' },
    }),
    columnHelper.accessor('amount1', {
        cell: info => {
            var _a;
            const activity = info.row.original;
            if (!activity.amount1 || !((_a = activity.currency1) === null || _a === void 0 ? void 0 : _a.code)) {
                return _jsx(NoDataPlaceholder, {});
            }
            const signFlip = activity.activityLabel === API.ActivityLabel.FundRedemption ? -1 : 1;
            return (_jsx(AmountQuantity, { value: activity.amount1.mul(signFlip), currencyCode: activity.currency1.code, color: "primary", signed: true, skipSignedColor: true }));
        },
        header: 'Amount',
        meta: { justify: 'flex-end' },
    }),
    columnHelper.accessor('statusFilter', {
        cell: () => {
            return _jsx(Tag, { label: "Completed", variant: "success", large: true });
        },
        header: 'Status',
        meta: { justify: 'flex-end' },
    }),
];
export function ActivityTable(_a) {
    var { data } = _a, rest = __rest(_a, ["data"]);
    return _jsx(Table, Object.assign({}, rest, { data: data, columns: columns }));
}
